import styled from 'styled-components'
import { Button as SharedButton } from '../../../shared/components'

export const Button = styled(SharedButton)`
  margin-top: 20px;
  width: 100%;
  height: 40px;
  font-size: 18px;
`
